/**
 * /mentions-legales — Mentions légales (Phase 11).
 */
import { LegalDocument } from '@/pages/LegalDocument';
import { legalFr } from '@/lib/legal/legal_fr';
import { legalEn } from '@/lib/legal/legal_en';
import { useLang, useT } from '@/lib/i18n';

export default function Legal() {
  const { lang } = useLang();
  const t = useT();
  const doc = lang === 'en' ? legalEn : legalFr;
  return (
    <LegalDocument
      doc={doc}
      path="/mentions-legales"
      testid="page-legal"
      courtesyNote={lang === 'en' ? t('legal.courtesy_note') : null}
    />
  );
}
